export const LOADING = 'LOADING';
export const SET_TOKEN = 'SET_TOKEN';
export const SET_USER = 'SET_USER';
export const SHOW_SIDEBAR = 'SHOW_SIDEBAR';
export const UNSAVED_CHANGE = 'UNSAVED_CHANGE';
export const SHOW_UNSAVEDCHANGEMODAL = 'SHOW_UNSAVEDCHANGEMODAL';
export const NOTIFICATION = 'NOTIFICATION';
